import { render, staticRenderFns } from "./UserWizardComponent.vue?vue&type=template&id=1233d51a&"
import script from "./UserWizardComponent.vue?vue&type=script&lang=js&"
export * from "./UserWizardComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports